import { Box, Flex, Typography } from "@jewlr/storybook/core"
import { FloatSelect } from "@jewlr/storybook/form"
import PropTypes from "prop-types"
import React, { useState } from "react"
import styled from "styled-components"

import { IS_PRODUCTION, IS_STAGING } from "helpers/application"

import ActiveDeal from "./active-deal"
import DealsGrid from "./deals-grid"

const Container = styled(Flex).attrs((props) => ({
  alignItems: "center",
  bg: "white",
  borderRadius: "30px",
  contain: true,
  gap: 3,
  justifyContent: "center",
  py: 3,
  ...props,
}))``

const setDefaultActiveIndex = (deals) => {
  const lastIndex = deals.findLastIndex(
    (deal) =>
      new Date() >= new Date(deal.start_time) &&
      new Date() < new Date(deal.end_time)
  )

  if (lastIndex >= 0) return lastIndex

  return 0
}

const LandingDaysOfDeals = ({ element, lazyload }) => {
  const [activeIndex, setActiveIndex] = useState(
    setDefaultActiveIndex(element.data.deals)
  )

  const activeDeal = element.data.deals[activeIndex]

  if (!activeDeal) return null

  return (
    <Box px={2} py={{ _: 4, desktop: 5 }} {...element.style?.block_style}>
      {!IS_PRODUCTION() && !IS_STAGING() && (
        <Flex
          alignItems="center"
          flexDirection={{ _: "column", desktop: "row" }}
          gap={3}
          justifyContent="center"
          mb={2}
          mx="auto"
        >
          <Typography color="white" variant="body">
            This row only shows in Dev
          </Typography>
          <Box width="300px">
            <FloatSelect
              label="Active deal: "
              onChange={(e) => setActiveIndex(Number(e.target.value))}
              placeholder="Active deal"
              value={activeIndex.toString()}
            >
              {[...Array(element.data.deals.length)].map((_, i) => (
                <option
                  key={`${element.anchor_name || element.id}-active-deal-${i}`}
                  value={i}
                >
                  {element.data.deals[i].grid_title}
                </option>
              ))}
            </FloatSelect>
          </Box>
        </Flex>
      )}
      <Container {...element.container_style}>
        <DealsGrid
          activeIndex={activeIndex}
          element={element}
          lazyload={lazyload}
        />
        <ActiveDeal
          activeIndex={activeIndex}
          element={element}
          lazyload={lazyload}
        />
      </Container>
    </Box>
  )
}

LandingDaysOfDeals.propTypes = {
  element: PropTypes.object,
  lazyload: PropTypes.bool,
}

export default LandingDaysOfDeals
